<template>
    <AppModal
        title="Live Chat Unavailable"
        :read-only="true"
    >
        <template #content>
            <div class="px-6 py-4 max-w-[700px]">
                <p class="text-base mb-4 type-secondary">
                    Your browser may be blocking live chat. This can happen when tracking prevention is set to strict or disabled.
                </p>
                
                <div class="mb-6">
                    <h3 class="text-lg font-medium mb-3 type-primary">Microsoft Edge Browser</h3>
                    <ol class="list-decimal list-inside space-y-2 text-sm type-secondary mb-4">
                        <li>Open Edge Settings</li>
                        <li>Go to Privacy, search, and services</li>
                        <li>Click on Tracking prevention</li>
                        <li>Select "Balanced" (recommended) or "Basic" instead of "Strict"</li>
                    </ol>
                    <div class="border-t border-keyline-primary py-4">
                        <p class="font-medium">
                            After adjusting your settings, refresh the page and try opening live chat again.
                        </p>
                    </div>
                    <div class="border rounded-lg overflow-hidden bg-gray-tier-5">
                        <img 
                            :src="marketingAssetUrl('edge-tracking-settings')" 
                            alt="Microsoft Edge Tracking Prevention Settings"
                            class="w-full h-auto"
                        />
                    </div>
                </div>
            </div>
        </template>
    </AppModal>
</template>

<script setup>
import { AppModal } from "@/Components";
import { useAssetTransforms } from "@/Composables";

defineProps(["data"]);

const { marketingAssetUrl } = useAssetTransforms();
</script>
